export const classes = {
  disabled: 'cursor-not-allowed',
  enabled: 'cursor-pointer',
};

export const styles = {
  iconButton: {
    '&.Mui-disabled': {
      cursor: 'not-allowed',
      pointerEvents: 'auto',
    },
  },
};
